exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content {\n  margin-top: 26px; }\n\n.mat-button {\n  margin-bottom: 40px; }\n\n.myPayments {\n  margin-top: 40px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Source/Ecim/Ecim.Web/src/app/components/update-application/update-application.component.scss
// module id = ../../../../../src/app/components/update-application/update-application.component.scss
// module chunks = main